import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "section",
        "parents",
        "modificationTemplate",
        "modificationCategoryTemplate"
    ]

    toggle(event) {
        this.sectionTarget.classList.toggle("hidden", !event.target.checked)
    }

    addParent(event) {
        event.preventDefault()
        const timestamp = new Date().getTime()
        const content = this.modificationCategoryTemplateTarget.innerHTML
            .replace(/NEW_CATEGORY/g, timestamp)

        this.parentsTarget.insertAdjacentHTML("beforeend", content)
    }

    addNested(event) {
        event.preventDefault()
        const container = event.target.closest("[data-category-id]")
        const modificationsTarget = container.querySelector("[data-modifications-target='children']")
        const categoryId = container.dataset.categoryId
        const timestamp = new Date().getTime()

        const content = this.modificationTemplateTarget.innerHTML
            .replace(/NEW_CATEGORY/g, categoryId)
            .replace(/NEW_MODIFICATION/g, timestamp)

        modificationsTarget.insertAdjacentHTML("beforeend", content)
    }

    removeNode(event) {
        event.preventDefault()
        const wrapper = event.target.closest("[data-removable]")
        const destroyInput = wrapper.querySelector("input[data-destroy-input]")

        if (destroyInput) {
            destroyInput.value = "1"
            wrapper.style.display = "none"
        } else {
            wrapper.remove()
        }
    }
}